import { ALL_APP_IDS, ALL_APPS, ALL_VIEWS } from 'constants/appConstants';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';
import { Redirect } from 'react-router6-redirect';

const Parts = Loadable(lazy(() => import('views/parts/PartsV2/Parts')));
const Part = Loadable(lazy(() => import('views/parts/PartsV2/PartWrapper')));

export const PartsRoutes = [
  // Deprecated Parts V1 Routes
  {
    path: `${ALL_APPS.PART_LIBRARY.path}`,
    element: <Redirect to={ALL_APPS[ALL_APP_IDS.PARTS].path ?? ''} />,
  },
  {
    path: `${ALL_VIEWS.PART_ALL.path}`,
    element: <Redirect to={ALL_APPS[ALL_APP_IDS.PARTS].path ?? ''} />,
  },
  {
    path: `${ALL_APPS.PART_SEARCH.deprecatedPath}`,
    element: <Redirect to={ALL_APPS[ALL_APP_IDS.PARTS].path ?? ''} />,
  },
  {
    path: `${ALL_APPS.PART_SEARCH.path}`,
    element: <Redirect to={ALL_APPS[ALL_APP_IDS.PARTS].path ?? ''} />,
  },
  {
    path: `${ALL_APPS.PART_SEARCH.deprecatedPath}/:partId`,
    element: <Redirect to={`${ALL_APPS[ALL_APP_IDS.PARTS].path}/:partId`} />,
  },
  {
    path: `${ALL_APPS.PART_SEARCH.path}/:partId`,
    element: <Redirect to={`${ALL_APPS[ALL_APP_IDS.PARTS].path}/:partId`} />,
  },
  // Parts V2 Routes
  {
    path: `${ALL_APPS.PARTS.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.PARTS.id,
        }}
      >
        <FullHeightMainCardWrapper>
          <Parts />
        </FullHeightMainCardWrapper>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.PARTS.path}/:partId`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.PARTS.id,
        }}
      >
        <Part />
      </PermissionsRouteWrapper>
    ),
  },
];
